import { Component, ViewChild, ElementRef } from '@angular/core';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { ButtonType, ModalButtons } from '@fcom/ui-components';
import { AppState, ConfigService } from '@fcom/core';
import { loginStatus } from '@fcom/core/selectors';
import { LoginStatus } from '@fcom/core-api/login';
import { finShare } from '@fcom/rx';

@Component({
  selector: 'fin-claim-missing-points-form',
  templateUrl: 'claim-missing-points-form.component.html',
  styleUrls: ['./claim-missing-points-form.component.scss'],
})
export class ClaimMissingPointsFormComponent {
  readonly LoginStatus = LoginStatus;
  readonly ModalButtons = ModalButtons;
  readonly loginStatus$: Observable<LoginStatus>;
  readonly ButtonType = ButtonType;

  @ViewChild('openHelpModalButton', { static: false })
  openHelpModalButton: ElementRef;

  helpModalOpen = false;
  requireLoginToClaimPoints = false;

  constructor(
    private store$: Store<AppState>,
    private configService: ConfigService
  ) {
    this.loginStatus$ = this.store$.pipe(loginStatus(), finShare());
    this.requireLoginToClaimPoints = this.configService.cfg.enableClaimMissingPointsLoggedIn;
  }

  openHelpModal(event: MouseEvent): void {
    event.stopPropagation();
    this.helpModalOpen = true;
  }

  blurHelpModal(): void {
    if (this.openHelpModalButton) {
      this.openHelpModalButton.nativeElement.focus();
    }
  }
}
